import React, { useCallback, useEffect, useState } from "react";
import { Button } from "@mui/material";
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { PDFPropostaDocument } from "./PDFDocument";
import { PRIMARY_COLOR } from "./utils";
import { readDataStorage } from "../../utils/storage/storage";
import Toast from "../Toast/Toast";
import errorIcon from "../Toast/Image/error.svg";

export function PDFPropostaButton({
  data,
  detalhamento,
  detalhamentoEconomia,
  mensalidade,
  urlDoLinkProsseguirAssinatura,
}: {
  data: any;
  detalhamento: any;
  detalhamentoEconomia: any;
  mensalidade: any;
  urlDoLinkProsseguirAssinatura: any;
}) {
  const { NomeRepresentante, RazaoRepresentante } = readDataStorage("login");
  const [invalidDate, setInvalidDate] = useState<boolean>(false);

  const [list, setList] = useState<any>([]);

  const showToast = useCallback(
    (type: any) => {
      let toastProperties: {
        id: number;
        title: string;
        description: string;
        backgroundColor: string;
        icon: any;
      } | null = null;

      const id = Math.floor(Math.random() * 101 + 1);
      switch (type) {
        case "erroData":
          toastProperties = {
            id,
            title: "",
            description:
              "Data inválida, não é possível baixar o PDF da proposta",
            backgroundColor: "#d72828",
            icon: errorIcon,
          };
          break;

        default:
          setList([]);
      }

      setList([...list, toastProperties]);
    },
    [list]
  );

  const formatDate = (dateString: string) => {
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) {
      return dateString;
    } else if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    } else {
      setInvalidDate(true);
      showToast("erroData");
    }
  };

  useEffect(() => {
    data?.tipoPessoa === "PF"
      ? formatDate(data?.pessoaFisica?.dataNascimento)
      : formatDate(data?.pessoaJuridica?.responsavel?.dataNascimento);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Toast toastList={list} autoDelete={true} />
      <div style={{ margin: "0 auto" }}>
        {invalidDate ? (
          <Button
            disabled
            variant="contained"
            size="large"
            endIcon={<TextSnippetOutlinedIcon />}
            style={{
              margin: "0 auto",
              fontFamily: "Kanit",
              backgroundColor: PRIMARY_COLOR,
              textTransform: "none",
              fontSize: "1.15rem",
            }}
          >
            Baixar PDF
          </Button>
        ) : (
          <PDFDownloadLink
            document={
              <PDFPropostaDocument
                data={data}
                detalhamento={detalhamento}
                detalhamentoEconomia={detalhamentoEconomia}
                mensalidade={`R$ ${mensalidade}`}
                urlDoLinkProsseguirAssinatura={urlDoLinkProsseguirAssinatura}
                NomeRepresentante={NomeRepresentante}
                RazaoRepresentante={RazaoRepresentante}
              />
            }
            fileName="proposta.pdf"
          >
            <Button
              variant="contained"
              size="large"
              endIcon={<TextSnippetOutlinedIcon />}
              style={{
                margin: "0 auto",
                fontFamily: "Kanit",
                backgroundColor: PRIMARY_COLOR,
                textTransform: "none",
                fontSize: "1.15rem",
              }}
            >
              Baixar PDF
            </Button>
          </PDFDownloadLink>
        )}
      </div>
    </>
  );
}
